import React, { useState } from "react";
import {
    Button, Dropdown, Menu, Modal
} from "antd";
import {
    DownOutlined, PlusOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { deepDiveColumns } from "../../../../config/TableColumns.config";
import { fGetBehaviorMatchAndColor, fGetInterestLevel } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import DeepDiveCollapseHeader from "../../../General/DeepDiveCollapseHeader";
import ColumnFilter from "../../../General/ColumnFilter";
import { setMarketCategoryTypeToAdd, setNewItemInCategoryDeepDive, setSelectedGeneralMarketCategory } from "../../../../store/components/Reports.slice";
import CategoryDeepDiveContent from "../CategoryDeepDive/CategoryDeepDiveContent";
import AddBehavioralSegmentModal from "../../../Modal/AddBehavioralSegmentModal";

function GeneralMarketCategoriesModal({
    visible,
    setIsVisible
}) {
    const dispatch = useDispatch();
    const [showAddBehaviouralSegment, setShowAddBehaviouralSegment] = useState(false);
    const [listOfHiddenColumns, setlistOfHiddenColumns] = useState({});
    const {
        selectedGeneralMarketCategory: data,
        selectedGeneralMarketCategoryIsLoading: isLoading, categoryDeepDiveData
    } = useSelector((state) => state.reports);

    const onChangeHiddenColumns = (params) => {
        const { value, group, key } = params;
        const newObj = {
            ...listOfHiddenColumns
        };
        if (!newObj[group]) newObj[group] = [];
        const currentList = newObj[group];

        if (!value && !currentList.includes(key)) {
            newObj[group].push(key);
        } else if (value && currentList.includes(key)) {
            newObj[group] = newObj[group].filter((k) => k !== key);
        }
        setlistOfHiddenColumns(newObj);
    };
    const { filteredColumns, filteredValues } = deepDiveColumns.reduce((acc, col) => {
        if (!col.type || col.type === "column") {
            acc.filteredColumns.push(col);
        } else {
            acc.filteredValues.push(col);
        }
        return acc;
    }, {
        filteredColumns: [],
        filteredValues: []
    });
    const { showedColumns, showedValues } = listOfHiddenColumns[1]?.length
        ? ({
            showedColumns: filteredColumns.filter((col) => (!listOfHiddenColumns[1].includes(col.key))),
            showedValues: filteredValues.filter((col) => (!listOfHiddenColumns[1].includes(col.key)))
        })
        : ({
            showedColumns: filteredColumns,
            showedValues: filteredValues
        });

    const toHideRowWithValue = showedValues.map((i) => i.key);

    const filteredItem = { ...data }
    filteredItem.children = filteredItem.children.reduce((acc, i) => {
        const newObj = {
            ...i,
            key: i.item,
            ...fGetBehaviorMatchAndColor(i.score)
        };

        if (toHideRowWithValue.length) {
            if (toHideRowWithValue.includes(newObj.behaviormatch)) {
                acc.push(newObj);
            }
        } else {
            acc.push(newObj);
        }
        return acc;
    }, []);

    const itemPercent = fGetInterestLevel(filteredItem.children);
    const itemStatus = fGetBehaviorMatchAndColor(itemPercent / 100);
    return (
        <Modal
            className="report--generalmarketcategories--modal"
            title="General Market Categories"
            open={visible}
            closable
            maskClosable={false}
            destroyOnClose
            onCancel={() => {
                setIsVisible(false);
            }}
            footer={(
                <Button onClick={() => {
                    setIsVisible(false);
                }}
                >
                    Close
                </Button>
            )}
        >
            <div style={{
                width: "100%",
                borderBottom: "1px solid  #E2E8F0",
                marginBottom: "2mm",
                paddingBottom: "2mm"
            }}
            >
                <span style={{
                    fontWeight: "600",
                    fontSize: "18px",
                    color: "#334155"
                }}
                >
                    {data.name}
                </span>
            </div>
            <div
                className={`d-flex align-items-center report--generalmarketcategories--itemHeader ${itemStatus.behaviormatch}`}
                style={{ width: "100%" }}
            >
                <DeepDiveCollapseHeader discoveredCategory={data.discoveredCategory} targetAudience={data.targetAudience} />
                <div className="d-flex gap-1">
                    <Dropdown
                        menu={(
                            <Menu onClick={(e) => {
                                switch (e.key) {
                                    case "addbehaviouralsegments": {
                                        dispatch(setMarketCategoryTypeToAdd("generalTile"));
                                        setShowAddBehaviouralSegment(true);
                                        break;
                                    }
                                    case "addtodashboard": {
                                        const lastGroup = categoryDeepDiveData[categoryDeepDiveData.length - 1].group;
                                        dispatch(setNewItemInCategoryDeepDive([{
                                            ...data,
                                            group: lastGroup + 1
                                        }]));
                                        setIsVisible(false);
                                        dispatch(setSelectedGeneralMarketCategory(null));
                                        break;
                                    }
                                    default:
                                }
                            }}
                            >
                                <Menu.Item
                                    key="addtodashboard"
                                    icon={<PlusOutlined />}
                                >
                                    Add to Dashboard
                                </Menu.Item>
                                <Menu.Item
                                    key="addbehaviouralsegments"
                                    icon={<PlusOutlined />}
                                >
                                    Add Behavioral Segments
                                </Menu.Item>
                            </Menu>
                        )}
                        disabled={isLoading}
                    >
                        <Button type="primary">
                            Action
                            <DownOutlined />
                        </Button>
                    </Dropdown>
                    <ColumnFilter
                        columns={deepDiveColumns}
                        group={1}
                        onChange={onChangeHiddenColumns}
                        hidden={listOfHiddenColumns[1]}
                    />
                </div>
            </div>
            <CategoryDeepDiveContent
                dontDeepDive
                data={filteredItem}
                interestLevel={itemPercent}
                itemStatus={itemStatus}
                columns={showedColumns}
                // onGetSubItems={onGetSubItems}
                filteredValues={toHideRowWithValue}
                loading={isLoading}
                fromSelectedTile
            />
            {showAddBehaviouralSegment && (
                <AddBehavioralSegmentModal
                    visible={showAddBehaviouralSegment}
                    onClose={setShowAddBehaviouralSegment}
                    data={data}
                />
            )}
        </Modal>

    );
}

export default GeneralMarketCategoriesModal;
